import React, { useState, useEffect } from "react";

import {
  IonButton,
  IonCol,
  IonGrid,
  IonModal,
  IonRow,
  IonAlert,
} from "@ionic/react";

import { CONSTANTS, ERROR } from "../../../constants";
import _ from "lodash";
import { utilService } from "../../../services/utilService";
import "./TeammatesToProvider.scss";
import { useToast } from "@agney/ir-toast";
import { SendGroupSmsResp } from "../GroupSms/GroupSms.model";
import { rolePermissionsService } from "../../../services/rolePermissions.service";
import { groupSmsService } from "../GroupSms/GroupSms.service";
import GroupSmsAccordion from "../HomeGroupSms/GroupSmsAccordion/GroupSmsAccordion";
import { OnCallLookUpInputService } from "../../../pages/OnCallLookUp/OnCalllookUpService";
import { dataTransferService } from "../../../services/dataTransferService";
import { useTranslation } from "react-i18next";

interface sendSmsProps {
  showModal: boolean;
  onCancel: () => void;
  onOk: () => void;
  doctorListDataFromParent: any;
  accordionList: any;
  patientID: any;
  caseDetailsPageProviderList?: any;
  isCancelledOrCancelled?: any;
  patientData?: any;
  updateCaseDetailsPage?: any;
}

const TeammatesToProvider: React.FC<sendSmsProps> = (props) => {
  const { t } = useTranslation("home");
  const [searchText, setSearchText] = useState("");
  const [comment, setComment] = useState<string>("");
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [sendSmsSubmitData, setSendSmsSubmitData] = useState<any>(Object);
  const [isSelectAll, setSelectAll] = useState(false);
  const [selectedDoctorCard, setSelectedDoctorDetails]: any = useState([]);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [currentErrorMessage, setCurrentErrorMessage]: any = useState();
  const [isInputEmpty, setIsInputEmpty] = useState(true);
  const [selectedAllStatus, setSelectedAllStatus] = useState(false);
  const [disableSendButton, setDisableSendButton] = useState(true);
  const [isSmallScreen, setIsSmallScreen]: any = useState(false);
  const [doctorData, setDoctorData]: any = useState([]);
  const [accordionListFromParent, setAccordionListFromParent]: any = useState({
    own: {},
    added: {},
  });

  const Toast = useToast();

  useEffect(() => {
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
    checkIfSmallScreen();
  }, []);

  useEffect(() => {
    setDoctorData(props.doctorListDataFromParent);
  }, [props.doctorListDataFromParent]);

  useEffect(() => {
    getNonEmptyAccordionList();
  }, [props.accordionList]);

  const deleteEmptyObject = (listObject: any) => {
    for (var listObjectItem in listObject) {
      if (listObject[listObjectItem].data.length === 0) {
        delete listObject[listObjectItem];
      }
    }
    return listObject;
  };

  const getNonEmptyAccordionList = () => {
    if (!_.isEmpty(props.accordionList)) {
      const ownListTemp = _.cloneDeep(props.accordionList.own);
      const addedListTemp = _.cloneDeep(props.accordionList.added);
      var ownList = deleteEmptyObject(ownListTemp);
      var addedList = deleteEmptyObject(addedListTemp);
      const accordionList = {
        own: ownList ? ownList : {},
        added: addedList ? addedList : {},
      };
      setAccordionListFromParent(_.cloneDeep(accordionList));
    }
  };

  useEffect(() => {
    disableGroupSmsButton();
  }, [isInputEmpty, selectedDoctorCard]);

  useEffect(() => {
    if (selectedAllStatus === true) {
      setSelectAll(true);
    }
  }, [selectedAllStatus]);

  useEffect(() => {
    if (selectedDoctorCard) {
    }
  }, [selectedDoctorCard]);

  async function sendGroupSms() {
    const params: any = getGroupSmsApiParams();

    const respSendSmsResult: SendGroupSmsResp =
      await groupSmsService.sendGroupSms(params);
    if (respSendSmsResult.isSuccess) {
    } else {
      console.log("error");
      groupSmsService.handleErrorResponse();
    }
    setSendSmsSubmitData(respSendSmsResult);
    showApiResponse(respSendSmsResult);
  }

  const getGroupSmsApiParams = () => {
    return {
      message_sms: comment,
      reg_code: utilService.getNetwork(),
      time: utilService.getCurrentDateAndTime(),
      users: getSelectedGuid(),
    };
  };

  const getSelectedGuid = () => {
    const selectedIds: any = [];
    selectedDoctorCard.map((item: any) => {
      selectedIds.push(item.guid);
    });
    return selectedIds;
  };

  const getSelectedCard = (selectedCard: any) => {
    setSelectedDoctorDetails(selectedCard);
  };

  const disableGroupSmsButton = () => {
    if (!selectedDoctorCard.length) {
      setDisableSendButton(true);
    } else {
      setDisableSendButton(false);
    }
  };

  const showApiResponse = (sendSmsData: any) => {
    if (sendSmsData.status !== 200) {
      setCurrentErrorMessage(t("smsFailed"));
      setIsShowAlert(true);
    } else if (sendSmsData.status === 200) {
      Toast.success(t("groupSmsSuccess"));
    }
  };

  const checkIfSmallScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  const updateProviderInCaseHistory = async () => {
    let apiParams = getProviderParams();
    const respProviderList: any =
      await OnCallLookUpInputService.setCaseHistoryProviderList(apiParams);
    if (respProviderList.isSuccess) {
      //this code is commented to fix the Bug #69796
      // let updateCase = props.caseDetailsPageProviderList
      //   ? dataTransferService.caseHistoryUpdatedAction(true)
      //   : "";

     Toast.success(t("providersUpdatedSuccess"));
      props.updateCaseDetailsPage(props.patientID);
    } else {
      Toast.error(respProviderList.message);
    }
  };

  const getProviderParams = () => {
    const apiParams = {
      patient_id: props.patientID,
      hour: utilService.getCurrentHour(),
      minute: utilService.getCurrentMinutes(),
      date: utilService.getCurrentDate(),
      reg_code: utilService.getNetwork(),
      guid: getSelectedGuid(),
      user_guid: utilService.getLoggedUserGuid(),
    };
    return apiParams;
  };

  return (
    <div>
      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => setIsShowAlert(false)}
        cssClass="sms-alert"
        message={currentErrorMessage}
        buttons={[
          {
           text: t("ok"),
            handler: () => {
              setIsShowAlert(false);
            },
          },
        ]}
      />
      <IonModal
        isOpen={props.showModal}
        backdropDismiss={false}
        className="teammates-provider-modal"
      >
        <div className="group-sms-modal-container">
          <div
            className={`group-sms-content ${
              isSmallScreen && "group-sms-content-small-screen"
            }`}
          >
            <div className="group-sms-header">{t("teammates")}</div>

            <div className="doctor-card-list-container">
              <IonGrid className="scrollbar">
                <IonRow>
                  <IonCol>
                    <GroupSmsAccordion
                      accordionList={accordionListFromParent}
                      isSelectAll={isSelectAll}
                      searchText={searchText}
                      getSelectedCard={getSelectedCard}
                      isFromEMSCaseDetails={true}
                    />
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>

            <div className="group-sms-button-container">
              <div className="cancel-button-div">
                <IonButton
                  color="medium"
                  className="button secondary-btn  btn-curved"
                  onClick={() => {
                    props.onCancel();
                  }}
                >
                  {t("cancel")}
                </IonButton>
              </div>
              <div className="send-button-div">
                <IonButton
                  className="submit-btn button primary-btn btn-curved"
                  disabled={disableSendButton}
                  onClick={() => {
                    updateProviderInCaseHistory();
                    props.onCancel();
                  }}
                >
                    {t("add")}
                </IonButton>
              </div>
            </div>
          </div>
        </div>
      </IonModal>
    </div>
  );
};

export default TeammatesToProvider;
